import { RolodexPermissionsValues } from 'types'
/**
 * Checks to see if any of the `permissionsToCheck` are in the `userPermissions` set.
 */
export function doesHaveRequiredPermissionsBase(
  userPermissions: ReadonlySet<string> | undefined,
  permissionsToCheck: RolodexPermissionsValues[]
): boolean {
  if (!userPermissions) {
    return false
  }

  return permissionsToCheck.some((permission) =>
    userPermissions.has(permission)
  )
}
